import React, { useContext, useState } from 'react';
import { AppContext } from '../../App';
import { openMediaUrl } from '../../utils/s3MediaUrl';

/**
 * Button-styled control that opens a possibly presigned S3 URL in a new tab after refresh.
 *
 * @param {Object} props
 * @param {string} props.url
 * @param {number|string} [props.quoteId]
 * @param {number|string} [props.productImageId]
 * @param {number|string} [props.orderImageId]
 * @param {string} [props.s3Key]
 * @param {string} [props.className]
 * @param {string} [props.title]
 * @param {React.ReactNode} props.children
 */
const S3MediaLink = ({
  url,
  quoteId,
  productImageId,
  orderImageId,
  s3Key,
  className = '',
  title = 'Open file',
  children,
}) => {
  const { token } = useContext(AppContext);
  const [isOpening, setIsOpening] = useState(false);

  const handleClick = async e => {
    e.preventDefault();
    e.stopPropagation();
    if (!url || isOpening) return;
    setIsOpening(true);
    try {
      await openMediaUrl(token, url, {
        quoteId,
        productImageId,
        orderImageId,
        s3Key,
      });
    } finally {
      setIsOpening(false);
    }
  };

  if (!url) return null;

  return (
    <button
      type="button"
      className={`btn btn-link p-0 border-0 ${className}`.trim()}
      title={title}
      disabled={isOpening}
      onClick={handleClick}
      onMouseDown={e => e.stopPropagation()}
    >
      {children}
    </button>
  );
};

export default S3MediaLink;
